export default "__VITE_ASSET__BcdybIku__"